// src/components/AboutSection.jsx
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import aboutImage from "../assets/about/teeth.png";
import c1 from "../assets/about/s.png";
import c2 from "../assets/about/s1.png";
import c3 from "../assets/about/s2.png"; 
import { PiMedalBold } from "react-icons/pi";

const AboutSection = () => {
  // Animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };
// Carousel logic
const carouselImages = [c1, c2, c3];
const [currentIndex, setCurrentIndex] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
  }, 3000); // change image every 3 seconds
  return () => clearInterval(interval);
}, []);


  return (
    <section className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-[5%]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Text Content */}
          <motion.div
            className="space-y-8"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.h2
              className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight"
              variants={fadeInUp}
            >
              Born from a love for bright smiles
              <br />
              <span className="text-gray-800">and healthy teeth</span>
            </motion.h2>

            <motion.div
              className="space-y-6 text-lg text-gray-600 leading-relaxed"
              variants={fadeInUp}
            >
              <p>
                At SRIDANTH, we believe that every child deserves a toothpaste
                that's not only safe and effective but also enjoyable. Our
                formulas are crafted with the utmost care, using natural
                ingredients that parents can trust and flavors that kids
                genuinely love.
              </p>
              <p>
                With over{" "}
                <span className="font-semibold text-gray-900">
                  25 years of expertise
                </span>{" "}
                in oral care, we've dedicated ourselves to creating products
                that make brushing a joyful experience for children while giving
                parents peace of mind.
              </p>
            </motion.div>

            {/* 98% Badge */}
            <motion.div
              className="inline-flex items-center gap-3 bg-gradient-to-r from-cyan-50 to-blue-50 px-6 py-3 rounded-full border border-cyan-200"
              variants={fadeInUp}
            >
              <div className="flex items-center justify-center w-10 h-10 bg-cyan-100 rounded-full">
                <PiMedalBold />
              </div>
              <div>
                <div className="text-2xl font-bold text-cyan-700">98%</div>
                <div className="text-sm font-medium text-cyan-600">
                  Satisfaction Rate
                </div>
              </div>
            </motion.div>
          </motion.div>

         {/* Right Image + Carousel */}
{/* Right Image + Carousel */}
<motion.div
  className="relative flex items-center justify-center w-full aspect-video md:aspect-[3/2] lg:aspect-[4/3] max-h-[500px] overflow-hidden rounded-3xl" // Changed this line
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-100px" }}
  variants={scaleIn}
>
  {/* Fixed Left Image */}
  <motion.img
    src={aboutImage}
    alt="Child with healthy teeth and Cheto Gel"
    className="absolute left-0 top-0 w-1/2 h-full object-cover rounded-l-3xl shadow-2xl" // Position absolutely to fill parent height
    variants={scaleIn}
  />

  {/* Carousel on Right */}
  <div className="absolute right-0 top-0 w-1/2 h-full overflow-hidden rounded-r-3xl shadow-2xl"> {/* Position absolutely */}
    <AnimatePresence mode="wait">
      <motion.img
        key={carouselImages[currentIndex]}
        src={carouselImages[currentIndex]}
        alt={`Carousel image ${currentIndex + 1}`}
        className="absolute inset-0 w-full h-full object-cover"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.8, ease: "easeInOut" }}
      />
    </AnimatePresence>
  </div>

  {/* Decorative circles */}
  <motion.div
    className="absolute -top-6 -right-6 w-32 h-32 bg-pink-100 rounded-full opacity-70 blur-3xl"
    animate={{ opacity: [0.5, 0.7, 0.5] }}
    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
  />
  <motion.div
    className="absolute -bottom-8 -left-8 w-40 h-40 bg-blue-100 rounded-full opacity-50 blur-3xl"
    animate={{ opacity: [0.3, 0.5, 0.3] }}
    transition={{
      duration: 3,
      repeat: Infinity,
      ease: "easeInOut",
      delay: 1,
    }}
  />
</motion.div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
